// extracted by mini-css-extract-plugin
export default {"overlay":"DeleteLossReasonButton_overlay__dB0NK","deleteIcon":"DeleteLossReasonButton_deleteIcon__ISFqK"};